import type { ReactNode } from "react";
import clsx from "clsx";

export interface ContextRowProps {
  label: string;
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  "data-testid"?: string;
}

/** Single labelled row in the audit inspector context panel. */
export function ContextRow({
  label,
  children,
  onClick,
  className = "",
  "data-testid": testId,
}: ContextRowProps) {
  const valueClass = "text-sm text-slate-200";

  return (
    <div className={className} data-testid={testId}>
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">
        {label}
      </p>
      {onClick ? (
        <button
          type="button"
          onClick={onClick}
          className={clsx(
            "mt-1 block max-w-full truncate text-left text-sm font-medium text-indigo-200",
            "hover:text-indigo-100"
          )}
        >
          {children}
        </button>
      ) : (
        <div className={clsx("mt-1", valueClass)}>{children}</div>
      )}
    </div>
  );
}

